import axios from "axios";

export const fetchChats = async ({ userId, offset = 0, limit = 10, query = "" }) => {
  try {
    const queryParams = new URLSearchParams({
      offset: offset.toString(),
      limit: limit.toString(),
    });

    if (query) {
      queryParams.append("query", query);
    }

    const { data } = await axios.get(
      `${process.env.REACT_APP_SPL_URL}/v2/tradegpt/chat/${userId}?${queryParams.toString()}`,
      { withCredentials: true },
    );
    return data;
  }
  catch (error) {
    console.error("Error fetching past chats:", error);
    throw error;
  }
};

export const deleteChat = async ({ session_id, user_id }: { session_id: string; user_id: string }) => {
  try {
    await axios.delete(`${process.env.REACT_APP_SPL_URL}/tradegpt-delete-chat`, {
      data: {
        user_id,
        session_id,
      },
      withCredentials: true,
    });
  }
  catch (error) {
    console.error("Error deleting chat:", error);
    throw error;
  }
};

export const deleteAllChats = async ({ user_id }: { user_id: string }) => {
  try {
    await axios.delete(`${process.env.REACT_APP_SPL_URL}/tradegpt-delete-user-chats/${user_id}`, { withCredentials: true });
  }
  catch (error) {
    console.error("Error deleting all chats:", error);
    throw error;
  }
};

export const renameChat = async ({ title, session_id }: { title: string; session_id: string }) => {
  try {
    await axios.put(`${process.env.REACT_APP_SPL_URL}/tradegpt-update-chat-title`, {
      session_title: title, session_id,
    }, { withCredentials: true });
  }
  catch (error) {
    console.error("Error renaming chat:", error);
    throw error;
  }
};
